import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { handleImageClick } from '../utils/imageUtils';

// Benches
import bench1 from "../assets/images/benches1.jpeg";
import bench2 from "../assets/images/benches2.jpeg";
import bench3 from "../assets/images/benches3.jpeg";
import bench4 from "../assets/images/benches4.jpeg";
import bench5 from "../assets/images/benches5.jpeg";
import bench6 from "../assets/images/benches6.jpeg";

// Cobble Stone Lying
import lying1 from "../assets/images/lying-and-path1.jpeg";
import lying2 from "../assets/images/lying-and-path2.jpeg";
import lying3 from "../assets/images/lying-and-path3.jpeg";
import lying4 from "../assets/images/lying-and-path4.jpeg";
import lying5 from "../assets/images/lying-and-path5.jpeg";
import lying6 from "../assets/images/lying-and-path6.jpeg";

// Cobble Stone Detail (Machine Cut)
import cobblestone1 from "../assets/images/CobblestoneMachineCut1.jpeg";
import cobblestone2 from "../assets/images/CobblestoneMachineCut2.jpeg";
import cobblestone3 from "../assets/images/CobblestoneMachineCut3.jpeg";
import cobblestone4 from "../assets/images/CobblestoneMachineCut4.jpeg";
import cobblestone5 from "../assets/images/CobblestoneMachineCut5.jpeg";
import cobblestone6 from "../assets/images/CobblestoneMachineCut6.jpeg";

// Kerb Stone
import kerb1 from "../assets/images/Kerb Stone1.jpeg";
import kerb2 from "../assets/images/Kerb Stone2.jpeg";
import kerb3 from "../assets/images/Kerb Stone3.jpeg";
import kerb4 from "../assets/images/Kerb Stone4.jpeg";
import kerb5 from "../assets/images/Kerb Stone5.jpeg";
import kerb6 from "../assets/images/Kerb Stone6.jpeg";

// Paving Stone
import paving1 from "../assets/images/Paving Stone1.jpeg";
import paving2 from "../assets/images/Paving Stone2.jpeg";
import paving3 from "../assets/images/Paving Stone3.jpeg";
import paving4 from "../assets/images/Paving Stone4.jpeg";
import paving5 from "../assets/images/Paving Stone5.jpeg";
import paving6 from "../assets/images/Paving Stone6.jpeg";

// Pergola
import pergola1 from "../assets/images/Pergola Stone1.jpeg";
import pergola2 from "../assets/images/Pergola Stone2.jpeg";
import pergola3 from "../assets/images/Pergola Stone3.jpeg";
import pergola4 from "../assets/images/Pergola Stone4.jpeg";
import pergola5 from "../assets/images/Pergola Stone5.jpeg";

// Wall Cladding
import wall1 from "../assets/images/Wall Cladding Stone1.jpeg";
import wall2 from "../assets/images/Wall Cladding Stone2.jpeg";
import wall3 from "../assets/images/Wall Cladding Stone3.jpeg";
import wall4 from "../assets/images/Wall Cladding Stone4.jpeg";
import wall5 from "../assets/images/Wall Cladding Stone5.jpeg";
import wall6 from "../assets/images/Wall Cladding Stone6.jpeg";

const categories = [

    {
        title: "Cobble Stone Detail",
        images: [cobblestone1, cobblestone2, cobblestone3, cobblestone4, cobblestone5, cobblestone6]
    },
    {
        title: "Kerb Stone",
        images: [kerb1, kerb2, kerb3, kerb4, kerb5, kerb6]
    },
    {
        title: "Paving Stone",
        images: [paving1, paving2, paving3, paving4, paving5, paving6]
    },
    {
        title: "Pergola",
        images: [pergola1, pergola2, pergola3, pergola4, pergola5]
    },
    {
        title: "Wall Cladding",
        images: [wall1, wall2, wall3, wall4, wall5, wall6]
    },
    {
        title: "Benches",
        images: [bench1, bench2, bench3, bench4, bench5, bench6]
    },
    {
        title: "Cobble Stone Lying",
        images: [lying1, lying2, lying3, lying4, lying5, lying6]
    },
];

const Gallery = () => {
    return (
        <Box sx={{ pb: 10 }}>
            <Container sx={{ py: 5 }}>
                <Box
                    sx={{
                        backgroundColor: "#f5f5f5",
                        p: { xs: 3, sm: 5, md: 8 },
                        mb: { xs: 5, md: 8 },
                        borderRadius: 2
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                    >
                        Explore Our Diverse Range of Products
                    </Typography>

                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: 32, sm: 40, md: 48 },
                            color: "#333"
                        }}
                    >
                        Our Gallery
                    </Typography>

                    <Box
                        sx={{
                            width: 80,
                            height: 4,
                            backgroundColor: "#1abc9c",
                            my: 3
                        }}
                    />

                    <Typography
                        variant="body1"
                        sx={{
                            color: "#555",
                            maxWidth: "800px",
                            fontSize: { xs: 14, md: 16 },
                            lineHeight: 1.6
                        }}
                    >
                        Welcome to our gallery. Here you can see a collection of our high-quality natural stone products.
                        Each piece is crafted with precision to meet the highest standards of our global clients.
                    </Typography>
                </Box>

                {categories.map((category, catIndex) => (
                    <Box key={catIndex} sx={{ mb: 10 }}>
                        {/* <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                mb: 2,
                                color: "#333",
                                fontSize: { xs: 24, md: 32 }
                            }}
                        >
                            {category.title}
                        </Typography> */}
                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                mb: 5
                            }}
                        />

                        <Grid container spacing={3}>
                            {category.images.map((image, imgIndex) => (
                                <Grid size={{ xs: 12, sm: 6, md: 6 }} key={imgIndex}>
                                    <Box
                                        component="img"
                                        src={image}
                                        alt={`${category.title} ${imgIndex + 1}`}
                                        onClick={() => handleImageClick(image)}
                                        sx={{
                                            width: "100%",
                                            height: { xs: 200, sm: 220, md: 250 },
                                            objectFit: "cover",
                                            border: "1px solid #ccc",
                                            borderRadius: 2,
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s, box-shadow 0.3s',
                                            '&:hover': {
                                                transform: 'scale(1.02)',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
                                            }
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </Container>
        </Box>
    );
};

export default Gallery;